import { sizes } from '@lmc/common/constants'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import Actions from '../../../actions'
import { Spinner } from '../../../components/generic'
import Operations from '../../../operations'
import Selectors from '../../../selectors'
import CurrentHandover from './components/CurrentHandover'
import { HandoversPaywall } from './components/HandoversPaywall'

export class CurrentHandoverScreen extends Component {
  componentDidMount() {
    this.props.fetchLists()
  }

  renderContent = () => {
    const {
      allHandovers,
      currentHandover,
      features,
      hasRecentHandover,
      hoursVisible,
      setHoursVisible
    } = this.props

    if (!allHandovers || !currentHandover || !features) return <Spinner />

    if (!features?.features?.handovers?.enabled) {
      return <HandoversPaywall />
    }

    const { logsByResident, notes } = currentHandover
    return (
      <CurrentHandover
        hasRecentHandover={hasRecentHandover}
        hoursVisible={hoursVisible}
        logsByResident={logsByResident}
        notes={notes}
        setHoursVisible={setHoursVisible}
      />
    )
  }

  render() {
    const { features } = this.props
    const container = features.pro
      ? { ...styles.mainContainer, ...styles.handoverContainer }
      : styles.mainContainer
    return <div style={container}>{this.renderContent()}</div>
  }
}

const styles = {
  mainContainer: {
    width: '100%',
    height: '85vh',
    margin: '0 auto'
  },
  handoverContainer: {
    maxWidth: sizes.childScreen,
    padding: '24px 24px'
  }
}

CurrentHandoverScreen.propTypes = {
  allHandovers: PropTypes.array,
  currentHandover: PropTypes.object,
  features: PropTypes.object,
  fetchCurrentHandover: PropTypes.func.isRequired,
  hasRecentHandover: PropTypes.bool.isRequired,
  hoursVisible: PropTypes.number,
  setHoursVisible: PropTypes.func.isRequired
}

const mapStateToProps = (state) => ({
  allHandovers: state.data.handovers,
  currentHandover: Selectors.formatCurrentHandover(state),
  features: state.global.home,
  hasRecentHandover: Selectors.getLatestHandoverTime(state) !== null,
  hoursVisible: state.handovers.hoursVisible
})

const mapDispatchToProps = (dispatch) => ({
  fetchLists: () => {
    dispatch(Operations.fetchCurrentHandover())
    dispatch(Operations.loadList('handovers'))
  },
  setHoursVisible: (hours) => dispatch(Actions.setHoursVisible(hours))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CurrentHandoverScreen)
